import axios from 'axios';

let baseURL = process.env.NODE_ENV === "development" ? "http://" + window.location.hostname + ":8000" : "https://" + window.location.hostname

const api = axios.create({
    baseURL: baseURL + "/api/v1"
})

export default api;